import React from "react";
import { NavLink } from "react-router-dom";
import logout from "../../../assets/logout.svg";
import useAuth from "../../../hooks/useAuth";
import SidebarLogo from "../SidebarLogo";
import classes from "./sidebar.module.css";

const Sidebar = () => {
   const { logoutUser } = useAuth();
   return (
      <div className={classes.container}>
         <SidebarLogo />
         <div className={classes.link__container}>
            <NavLink
               to="/user/dashboard"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Dashboard
            </NavLink>
            <NavLink
               to="/user/donations"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Donation History
            </NavLink>
            <NavLink
               to="/user/hymn"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Hymns & Devotionals
            </NavLink>
            <NavLink
               to="/user/events"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Church Events
            </NavLink>
            <NavLink
               to="/user/subscription"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Subscription Payment History
            </NavLink>
            <NavLink
               to="/user/resources"
               className={({ isActive }) =>
                  isActive ? `${classes.active} ${classes.link}` : classes.link
               }
            >
               Resources
            </NavLink>
         </div>
         <div className={classes.logout__button} onClick={logoutUser}>
            <img src={logout}></img>
            <span>Logout</span>
         </div>
      </div>
   );
};

export default Sidebar;
